export default __webpack_public_path__ + "static/media/userIcon.9dcf5fd8.svg";